import { createContext } from "react";

const parameterContext = createContext();

export default parameterContext;
